export default __webpack_public_path__ + "static/media/ReimbursementBackground.49a857d2.svg";